const embgRegex = /(^[0-9]{13}$)/;
const bankIdRegex = /(^[0-9]{3}-[0-9]{10}-[0-9]{2}$)/;

export { embgRegex, bankIdRegex };
